module.exports = __webpack_public_path__ + "static/media/back-icon.deb28e7e.svg";